import { ARC_END_ANGLE, ARC_START_ANGLE } from '../constants.js';
import { useGaugeChartAspectRatio } from './useGaugeChartAspectRatio.js';
import { polarToCartesian } from '../utils/polar-to-cartesian.js';

export const useGaugeChartMinMaxLabelsPosition = () => {
  const { arcMiddleRadius } = useGaugeChartAspectRatio();

  const minLabelPosition = polarToCartesian(arcMiddleRadius, ARC_START_ANGLE);
  const maxLabelPosition = polarToCartesian(arcMiddleRadius, ARC_END_ANGLE);

  return {
    minLabelPosition,
    maxLabelPosition,
  };
};
